/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  UserVote,
  UserVoteInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create a user vote
 */
export const createUserVote = (
    userVoteInput?: MaybeRefOrGetter<UserVoteInput>,
 signal?: AbortSignal
) => {
      userVoteInput = toValue(userVoteInput);

      return axiosClient<UserVote>(
      {url: `/user_votes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userVoteInput, signal
    },
      );
    }




export const getCreateUserVoteMutationKey = () => ['createUserVote'] as const;

export const getCreateUserVoteMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserVote>>, TError,CreateUserVoteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUserVote>>, TError,CreateUserVoteMutationVariables, TContext> => {

const mutationKey = getCreateUserVoteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserVote>>, CreateUserVoteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createUserVote(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserVoteMutationResult = NonNullable<Awaited<ReturnType<typeof createUserVote>>>
    export type CreateUserVoteMutationBody = UserVoteInput | undefined
    export type CreateUserVoteMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateUserVoteMutationVariables = {data?: UserVoteInput}

    /**
 * @summary Create a user vote
 */
export const useCreateUserVote = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserVote>>, TError,CreateUserVoteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createUserVote>>,
        TError,
        CreateUserVoteMutationVariables,
        TContext
      > => {
      return useMutation(getCreateUserVoteMutationOptions(options), queryClient);
    }
